export const contentTableConfig = {
  propList: [
    {
      prop: 'name',
      label: '活动名称',
      slotName: 'name'
    },
    { prop: 'createTime', label: '发放时间', slotName: 'createTime'},
    { prop: 'dpName', label: '归属门店', slotName: 'dpName'},
    {
      prop: 'cardName',
      label: '卡名称',
      slotName: 'cardName'
    },
    {
      prop: 'sendNum',
      label: '发放数量',
      slotName: 'sendNum'
    },
    // { label: '操作', minWidth: '200', slotName: 'handler', }
  ],
  showIndexColumn: false,
  showSelectColumn: true
}
